<template>
  <main id="main" style="margin-top:200px; padding-bottom:50px">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="section-header">
            <h2>Landing Page</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <select name="landingType" class="form-control uniSelect" v-model="selectedType">
            <option value="property">Property Campaign</option>
            <option value="timeshare">Timeshare Campaign</option>
          </select>
        </div>
      </div>
      <div v-if="selectedType === 'property'" class="row">
        <propertyLanding passedDown="0" />
      </div>
      <div v-if="selectedType === 'timeshare'" class="row">
        <timeshareLanding passedDown="0" />
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import propertyLanding from "./landingPageProperty";
import timeshareLanding from "./landingPage";
export default {
  components: {
    propertyLanding,
    timeshareLanding
  },
  data() {
    return {
      selectedType: ""
    };
  }
};
</script>

<style lang="scss" scoped></style>
